import { onClickOutsideElement } from "Libs/onClickOutsideElement";

/**
 * @param {HTMLElement} header
 */
export const initHeaderSearch = (header) => {
  const search = document.getElementById("search");
  const search_button = search.querySelector(".search__btn");
  const search_field = search.querySelector(".search__field");

  if (search) {
    function toggleSearch() {
      search.classList.toggle("open");

      if (search.classList.contains("open")) {
        search_field.focus();
      }

      onClickOutsideElement(search);
    }

    search_button.addEventListener("click", function () {
      if (
        search.classList.contains("open") &&
        search_field.value.trim() !== ""
      ) {
        search.submit();
      } else {
        toggleSearch();
      }
    });
  }
};
